import React, { ReactNode } from 'react';
import { colors } from '../../Theme/Colors';

type Props = {
  value?: string | ReactNode;
  percent?: boolean;
  title: string | ReactNode;
  width?: string;
};

export const DashBoardCard = (props: Props) => {
  const isRTL = document.documentElement.dir === 'rtl';
  return (
    <div
      style={{
        backgroundColor: '#F6F8FB',
        padding: '1.5rem',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        width: props.width || '49%',
        borderRadius: '1rem',
      }}
    >
      <div
        style={{
          fontSize: '3rem',
          fontWeight: 700,
          lineHeight: '3.875rem',
          fontStyle: 'normal',
          color: colors.primaryColor,
        }}
      >
        {props.percent ? (isRTL ? '٪' : '%') : ''}
        {props.value}
      </div>
      <div
        style={{
          fontSize: '1.5rem',
          fontWeight: 600,
          lineHeight: '2rem',
          fontStyle: 'normal',
          color: colors.primaryColor,
        }}
      >
        {props.title}
      </div>
    </div>
  );
};
